import React, { useState, useEffect } from "react";
import logo from "../../assets/footerLogo.png";
import mobileLogo from "../../assets/footerLogo.png";
import Modal from "react-modal";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import { useStrapperContext } from "../Strapper/StrapperContext";
import StrapperFrom from "../StraperFrom";
import axios from "axios";

const Header = ({ headerData }) => {
  const { setStraper } = useStrapperContext();
  const [showSideBar, setShowSideBar] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(showSideBar);
  const [isCartOpen, setCartOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [navData, setNavData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          const scrolled = scrollTop > 50; // Reduced threshold for earlier transition
          setIsScrolled(scrolled);

          // Smooth body padding transition
          if (scrolled) {
            document.body.classList.add("header-scrolled");
          } else {
            document.body.classList.remove("header-scrolled");
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.classList.remove("header-scrolled");
    };
  }, []);

  useEffect(() => {
    const getNavData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/navbar`,
        );
        const sortedNavData = [...response.data.data].sort(
          (a, b) => a.order - b.order,
        );
        setNavData(sortedNavData);
        setIsDataLoaded(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (navData.length === 0 && !isDataLoaded) {
      getNavData();
    }
  }, [navData, isDataLoaded]);

  const handleOpenCart = () => {
    setStraper(4);
    setCartOpen(true);
  };

  const handleCloseCart = () => setCartOpen(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const customStyles = {
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 0,
      border: "none",
      background: "transparent",
      width: "375px",
      height: "100vh",
      overflowY: "hidden",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
    },
    overlay: {
      background: "rgba(13, 18, 27, 0.6)",
      zIndex: 999999,
    },
  };

  if (showSideBar && !modalIsOpen) {
    openModal();
  }
  if (!showSideBar && modalIsOpen) {
    closeModal();
  }

  return (
    <>
      {isCartOpen && (
        <Modal
          isOpen={isCartOpen}
          onRequestClose={handleCloseCart}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              overflowY: "auto",
              zIndex: 999999,
            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              width: "900px",
              height: "700px",
              backgroundColor: "#f8f8f8",
              padding: "0",
              paddingBottom: "0px",
              marginBottom: "10px",
              borderRadius: "30px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            },
          }}
          ariaHideApp={false}
        >
          <StrapperFrom
            onClose={handleCloseCart}
            setStraper={setStraper}
            back={false}
          />
        </Modal>
      )}

      {/* Desktop Header */}
      <div
        className="lg:flex lg:flex-col hidden relative bg-white w-full z-[9999] transition-all duration-300 ease-out"
        style={{
          boxShadow:
            "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
        }}
      >
        <div
          className={`transition-all duration-500 ease-out overflow-hidden ${isScrolled ? "max-h-0 opacity-0" : "opacity-100"}`}
        >
          <div className="flex justify-between items-center">
            <div className="flex ml-[50px] xl:ml-[101px] mr-[31px] xl:mr-[51px]">
              <Link
                to="/"
                className="flex items-center w-[120px] h-max xl:w-[200px] p-3"
              >
                <img
                  src={mobileLogo}
                  alt="Logo"
                  className="w-full h-full object-contain"
                />
              </Link>
            </div>
            <div className="flex justify-end w-full gap-5">
              <div className="flex items-center gap-3">
                <div className="rounded-[30px] bg-[#E3EBFD] flex justify-center items-center w-[32px] h-[32px]">
                  <svg
                    className="w-[21px] h-[15px]"
                    viewBox="0 0 21 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.4395 4.96094C20.5957 4.84375 20.8301 4.96094 20.8301 5.15625V13.125C20.8301 14.1797 19.9707 15 18.9551 15H2.70508C1.65039 15 0.830078 14.1797 0.830078 13.125V5.15625C0.830078 4.96094 1.02539 4.84375 1.18164 4.96094C2.08008 5.66406 3.21289 6.52344 7.19727 9.41406C8.01758 10 9.42383 11.2891 10.8301 11.2891C12.1973 11.2891 13.6426 10 14.4238 9.41406C18.4082 6.52344 19.541 5.66406 20.4395 4.96094ZM10.8301 10C9.89258 10.0391 8.60352 8.86719 7.93945 8.39844C2.74414 4.64844 2.35352 4.29688 1.18164 3.35938C0.947266 3.20312 0.830078 2.92969 0.830078 2.61719V1.875C0.830078 0.859375 1.65039 0 2.70508 0H18.9551C19.9707 0 20.8301 0.859375 20.8301 1.875V2.61719C20.8301 2.92969 20.6738 3.20312 20.4395 3.35938C19.2676 4.29688 18.877 4.64844 13.6816 8.39844C13.0176 8.86719 11.7285 10.0391 10.8301 10Z"
                      fill="#183864"
                    />
                  </svg>
                </div>
                <div className="text-[#183864] font-bold text-[16px]">
                  {headerData?.email}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="rounded-[30px] bg-[#E3EBFD] flex justify-center items-center w-[32px] h-[32px]">
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      strokeWidth="evenodd"
                      d="M6.45703 10.0007C6.45703 14.5732 8.49953 16.749 9.38786 17.4857C9.56453 17.6315 9.81036 17.709 10.1162 17.709L11.7187 17.709C12.3554 17.709 12.8662 17.0573 12.662 16.3598L12.1737 14.6932C12.042 14.2448 11.6512 13.959 11.2304 13.959L10.717 13.959L10.717 13.334C10.717 13.959 10.7162 13.959 10.7154 13.959L10.6854 13.959C10.638 13.9569 10.5909 13.9507 10.5445 13.9407C10.467 13.9257 10.372 13.899 10.267 13.8507C10.0529 13.7532 9.81703 13.579 9.60203 13.2865C9.18286 12.7148 8.87036 11.7248 8.87036 10.0007C8.87036 8.27565 9.18286 7.28648 9.60203 6.71482C9.8162 6.42232 10.052 6.24815 10.267 6.15065C10.3871 6.09583 10.5151 6.06039 10.6462 6.04565L10.6862 6.04315L10.7029 6.04315L10.7095 6.04232L10.7154 6.04232C10.7154 6.04232 10.717 6.04232 10.717 6.66732L10.717 6.04232L11.0404 6.04232C11.512 6.04232 11.9387 5.68315 12.0154 5.15898L12.2595 3.49232C12.3562 2.83815 11.8662 2.29232 11.2845 2.29232L9.5137 2.29232C9.14703 2.29232 8.8587 2.40648 8.67786 2.60898C7.92953 3.44565 6.45703 5.63898 6.45703 10.0007ZM10.777 7.29232L11.0404 7.29232C12.1629 7.29232 13.0904 6.44732 13.2529 5.34065L13.497 3.67399C13.697 2.31232 12.6762 1.04232 11.2845 1.04232L9.5137 1.04232C8.90286 1.04232 8.2287 1.23398 7.7462 1.77565C6.7962 2.83898 5.20703 5.32648 5.20703 10.0007C5.20703 15.009 7.4687 17.5182 8.59036 18.4482C9.05036 18.829 9.60703 18.959 10.1162 18.959L11.7187 18.959C13.2462 18.959 14.2845 17.4507 13.8612 16.009L13.3729 14.3423C13.0929 13.384 12.2304 12.709 11.2312 12.709L10.777 12.709C10.7102 12.6684 10.6533 12.6134 10.6104 12.5482C10.4187 12.2865 10.1204 11.6098 10.1204 10.0007C10.1204 8.39232 10.4187 7.71482 10.6104 7.45315C10.6895 7.34482 10.752 7.30482 10.777 7.29232Z"
                      fill="#183864"
                    />
                  </svg>
                </div>
                <div className="text-[#183864] font-bold text-[16px]">
                  {headerData?.phone}
                </div>
              </div>
              <div
                className="flex items-center cursor-pointer gap-3"
                onClick={handleOpenCart}
              >
                <div className="rounded-[30px] bg-[#E3EBFD] flex justify-center items-center w-[48px] h-[48px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="fill-[#183864] w-6 h-6"
                  >
                    <path d="M7 18c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm-7-16v2h2l3.6 7.59-1.35 2.44c-.16.29-.25.63-.25.97 0 1.104.896 2 2 2h12v-2h-11.42c-.14 0-.25-.11-.25-.25l.03-.12 1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.3.12-.48 0-.55-.45-1-1-1h-14.79l-.94-2h-3.27zm16 16c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2z" />
                  </svg>
                </div>
                <div className="text-[#183864] font-bold text-[16px]">Cart</div>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex justify-center items-center">
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337Z"
                      stroke="#183864"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.66667 2.5H7.5C5.875 7.36667 5.875 12.6333 7.5 17.5H6.66667"
                      stroke="#183864"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12.5 2.5C14.125 7.36667 14.125 12.6333 12.5 17.5"
                      stroke="#183864"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2.5 13.3333V12.5C7.36667 14.125 12.6333 14.125 17.5 12.5V13.3333"
                      stroke="#183864"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2.5 7.5C7.36667 5.875 12.6333 5.875 17.5 7.5"
                      stroke="#183864"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="flex">
                  <div className="text-[#183864] text-[14px]">
                    {headerData?.languages}
                  </div>
                  <div className="flex items-center">
                    <svg
                      className="w-5 h-[21px]"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.9336 8.31641H9.74194H5.06695C4.26695 8.31641 3.86695 9.28307 4.43361 9.84974L8.75028 14.1664C9.44195 14.8581 10.5669 14.8581 11.2586 14.1664L12.9003 12.5247L15.5753 9.84974C16.1336 9.28307 15.7336 8.31641 14.9336 8.31641Z"
                        fill="#183864"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`transition-all duration-300 ease-out ${isScrolled ? "transform -translate-y-2" : ""}`}
        >
          <Navbar />
        </div>
      </div>

      {/* Sticky Navigation Only */}
      <div
        className={`lg:block hidden fixed left-1/2 transform -translate-x-1/2 z-[99999] max-w-7xl w-[95%] mx-auto transition-all duration-500 ease-out ${
          isScrolled
            ? "top-4 opacity-100 translate-y-0"
            : "-top-20 opacity-0 translate-y-4"
        }`}
        style={{
          boxShadow: isScrolled ? "0 10px 30px rgba(0, 0, 0, 0.15)" : "none",
        }}
      >
        <div className="bg-[#073967] min-h-[60px] rounded-2xl">
          <div className="p-4">
            <div className="flex items-center justify-center w-[55%] m-auto">
              <div className="flex justify-between w-full">
                {navData.length > 0 &&
                  navData.map((item, index) => (
                    <Link
                      key={index}
                      to={item.url}
                      className={`nav-link ${location.pathname.includes(item.url) ? "text-white" : "text-[#9A9EA6]"} font-medium text-[16px] leading-[24px] cursor-pointer transition-colors duration-300 hover:text-white`}
                    >
                      {item.name}
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Design */}
      <div
        className={`w-full lg:hidden flex flex-col p-4 transition-all duration-500 ease-out ${
          isScrolled
            ? "fixed top-0 left-0 right-0 z-[99999] bg-white shadow-lg"
            : "relative shadow-md z-[9999]"
        }`}
        style={{
          boxShadow: isScrolled
            ? "0 2px 10px rgba(0, 0, 0, 0.15)"
            : "0 -2px 10px 0 rgba(0, 0, 0, 0.2)",
          transform: isScrolled ? "translateY(0)" : "translateY(0)",
        }}
      >
        <div className="flex justify-between items-center">
          <div className="cursor-pointer">
            <Link to="/" className="flex items-center">
              <img
                src={mobileLogo}
                alt="Mobile logo"
                className="w-[90px] h-max object-contain"
              />
            </Link>
          </div>
          <div className="cursor-pointer" onClick={() => setShowSideBar(true)}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                strokeWidth="evenodd"
                d="M3.42857 5C2.6396 5 2 5.6396 2 6.42857C2 7.21754 2.6396 7.85714 3.42857 7.85714H26.2857C27.0747 7.85714 27.7143 7.21754 27.7143 6.42857C27.7143 5.6396 27.0747 5 26.2857 5H3.42857ZM4.85714 15C4.85714 14.211 5.49674 13.5714 6.28571 13.5714H23.4286C24.2176 13.5714 24.8571 14.211 24.8571 15C24.8571 15.789 24.216 16.4286 23.4286H6.28571C5.49674 16.4286 4.85714 15.789 4.85714 15ZM7.71429 23.5714C7.71429 22.7824 8.35389 22.1429 9.14286 22.1429H20.5714C21.3604 22.429 22 23.5714C22 24.3604 21.3604 25 20.5714 25H9.14286C8.35389 25 7.71429 24.3604 7.71429 23.5714Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        {modalIsOpen && (
          <Modal
            isOpen={modalIsOpen}
            style={{
              ...customStyles,
              content: {
                ...customStyles.content,
                transform: modalIsOpen ? "translateY(0)" : "translateY(-100%)",
              },
            }}
            ariaHideApp={false}
          >
            <motion.div
              initial={{ y: -100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="max-w-[430px] min-w-[375px] bg-gradient-to-b from-white to-gray-50 shadow-xl rounded-b-3xl overflow-hidden max-h-screen flex flex-col"
              style={{ boxShadow: "0 10px 30px rgba(24, 56, 100, 0.15)" }}
            >
              {/* Header Section */}
              <div className="w-full p-6 bg-gradient-to-r from-[#183864] to-[#2a4d7a] relative overflow-hidden">
                {/* Background decoration */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>

                <div className="flex justify-between items-center relative z-10">
                  <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="cursor-pointer"
                  >
                    <img
                      src={logo}
                      alt="ProSafe Logo"
                      className="w-[90px] h-max drop-shadow-lg"
                    />
                  </motion.div>
                  <motion.div
                    initial={{ rotate: -180, opacity: 0 }}
                    animate={{ rotate: 0, opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    className="cursor-pointer bg-white/20 backdrop-blur-sm rounded-full p-2 hover:bg-white/30 transition-all duration-300"
                    onClick={() => setShowSideBar(false)}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="white"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </motion.div>
                </div>

                {/* Contact Info in Header */}
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.4 }}
                  className="mt-4 flex justify-between items-center text-white/90 text-sm relative z-10"
                >
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                      <svg
                        className="w-[21px] h-[15px]"
                        viewBox="0 0 21 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.4395 4.96094C20.5957 4.84375 20.8301 4.96094 20.8301 5.15625V13.125C20.8301 14.1797 19.9707 15 18.9551 15H2.70508C1.65039 15 0.830078 14.1797 0.830078 13.125V5.15625C0.830078 4.96094 1.02539 4.84375 1.18164 4.96094C2.08008 5.66406 3.21289 6.52344 7.19727 9.41406C8.01758 10 9.42383 11.2891 10.8301 11.2891C12.1973 11.2891 13.6426 10 14.4238 9.41406C18.4082 6.52344 19.541 5.66406 20.4395 4.96094ZM10.8301 10C9.89258 10.0391 8.60352 8.86719 7.93945 8.39844C2.74414 4.64844 2.35352 4.29688 1.18164 3.35938C0.947266 3.20312 0.830078 2.92969 0.830078 2.61719V1.875C0.830078 0.859375 1.65039 0 2.70508 0H18.9551C19.9707 0 20.8301 0.859375 20.8301 1.875V2.61719C20.8301 2.92969 20.6738 3.20312 20.4395 3.35938C19.2676 4.29688 18.877 4.64844 13.6816 8.39844C13.0176 8.86719 11.7285 10.0391 10.8301 10Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <span className="text-xs font-medium">
                      {headerData?.email}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          strokeWidth="evenodd"
                          d="M6.45703 10.0007C6.45703 14.5732 8.49953 16.749 9.38786 17.4857C9.56453 17.6315 9.81036 17.709 10.1162 17.709L11.7187 17.709C12.3554 17.709 12.8662 17.0573 12.662 16.3598L12.1737 14.6932C12.042 14.2448 11.6512 13.959 11.2304 13.959L10.717 13.959L10.717 13.334C10.717 13.959 10.7162 13.959 10.7154 13.959L10.6854 13.959C10.638 13.9569 10.5909 13.9507 10.5445 13.9407C10.467 13.9257 10.372 13.899 10.267 13.8507C10.0529 13.7532 9.81703 13.579 9.60203 13.2865C9.18286 12.7148 8.87036 11.7248 8.87036 10.0007C8.87036 8.27565 9.18286 7.28648 9.60203 6.71482C9.8162 6.42232 10.052 6.24815 10.267 6.15065C10.3871 6.09583 10.5151 6.06039 10.6462 6.04565L10.6862 6.04315L10.7029 6.04315L10.7095 6.04232L10.7154 6.04232C10.7154 6.04232 10.717 6.04232 10.717 6.66732L10.717 6.04232L11.0404 6.04232C11.512 6.04232 11.9387 5.68315 12.0154 5.15898L12.2595 3.49232C12.3562 2.83815 11.8662 2.29232 11.2845 2.29232L9.5137 2.29232C9.14703 2.29232 8.8587 2.40648 8.67786 2.60898C7.92953 3.44565 6.45703 5.63898 6.45703 10.0007ZM10.777 7.29232L11.0404 7.29232C12.1629 7.29232 13.0904 6.44732 13.2529 5.34065L13.497 3.67399C13.697 2.31232 12.6762 1.04232 11.2845 1.04232L9.5137 1.04232C8.90286 1.04232 8.2287 1.23398 7.7462 1.77565C6.7962 2.83898 5.20703 5.32648 5.20703 10.0007C5.20703 15.009 7.4687 17.5182 8.59036 18.4482C9.05036 18.829 9.60703 18.959 10.1162 18.959L11.7187 18.959C13.2462 18.959 14.2845 17.4507 13.8612 16.009L13.3729 14.3423C13.0929 13.384 12.2304 12.709 11.2312 12.709L10.777 12.709C10.7102 12.6684 10.6533 12.6134 10.6104 12.5482C10.4187 12.2865 10.1204 11.6098 10.1204 10.0007C10.1204 8.39232 10.4187 7.71482 10.6104 7.45315C10.6895 7.34482 10.752 7.30482 10.777 7.29232Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <span className="text-xs font-medium">
                      {headerData?.phone}
                    </span>
                  </div>
                </motion.div>
              </div>

              {/* Navigation Menu */}
              <div className="px-6 py-8 flex-1 overflow-y-auto">
                <div className="flex flex-col space-y-1">
                  {navData.map((item, index) => (
                    <motion.div
                      key={item._id || item.name}
                      initial={{ x: -50, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: 0.1 * index, duration: 0.5 }}
                    >
                      <Link
                        to={item.url}
                        className="group flex items-center gap-4 p-4 rounded-2xl hover:bg-gradient-to-r hover:from-[#183864] hover:to-[#2a4d7a] transition-all duration-300 hover:shadow-lg hover:scale-105 active:scale-95"
                        onClick={() => setShowSideBar(false)}
                      >
                        <div className="w-10 h-10 bg-[#E9EFFF] group-hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110">
                          <span className="text-lg group-hover:scale-110 transition-transform duration-300">
                            {item.name.charAt(0)}
                          </span>
                        </div>
                        <span className="font-semibold text-lg text-[#183864] group-hover:text-white transition-colors duration-300">
                          {item.name}
                        </span>
                        <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 15L12.5 10L7.5 5"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </Link>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Footer CTA */}
              <div className="px-6 pb-6">
                <motion.div
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.8 }}
                  className="bg-gradient-to-r from-[#B02526] to-[#d63031] rounded-2xl p-4 text-white"
                >
                  <div className="text-center">
                    <h3 className="text-lg font-bold mb-2">
                      Ready to Get Started?
                    </h3>
                    <p className="text-sm opacity-90 mb-4">
                      Join thousands learning with ProSafe
                    </p>
                    <div className="flex gap-2">
                      <Link
                        to="/training"
                        className="flex-1 bg-white text-[#B02526] py-3 rounded-xl font-bold text-sm hover:bg-gray-100 transition-colors duration-300 text-center"
                        onClick={() => setShowSideBar(false)}
                      >
                        Book Course
                      </Link>
                      <button
                        className="flex-1 border-2 border-white text-white py-3 rounded-xl font-bold text-sm hover:bg-white hover:text-[#B02526] transition-colors duration-300"
                        onClick={handleOpenCart}
                      >
                        View Cart
                      </button>
                    </div>
                  </div>
                </motion.div>
              </div>

              {/* Bottom Border */}
              <div className="h-1 bg-gradient-to-r from-[#183864] via-[#B02526] to-[#183864]"></div>
            </motion.div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default Header;
